import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { usePortfolioSettings } from "../../hooks/usePortfolioData";

function Home() {
  const { settings } = usePortfolioSettings();

  // Settings are already loaded by the hook, no need to refetch
  
  // Fallback to defaults if not loaded - handle null/empty explicitly
  const homeMainImage = (settings?.home_main_image && settings.home_main_image.trim() !== '') 
    ? settings.home_main_image 
    : '/Assets/home-main.png';
  const homeGreeting = settings?.home_greeting || 'Hi folks!';
  const homeName = settings?.home_name || 'Firas Bayoudhi';

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                {homeGreeting}{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I am
                <strong className="main-name"> {homeName}</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeMainImage}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "500px" }}
                onError={(e) => {
                  e.target.src = '/Assets/home-main.png';
                }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
